export default "__VITE_ASSET__CZ6v1IyI__"